import { render, staticRenderFns } from "./MobileChatMessages.vue?vue&type=template&id=7ed2fb03&scoped=true"
import script from "./MobileChatMessages.vue?vue&type=script&lang=js"
export * from "./MobileChatMessages.vue?vue&type=script&lang=js"
import style0 from "./MobileChatMessages.vue?vue&type=style&index=0&id=7ed2fb03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed2fb03",
  null
  
)

export default component.exports